"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _Button = require("../Button");

var _Icons = require("../Icons");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var noop = function noop() {};

var CloseButton = function CloseButton(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop : _ref$onClick;
  return _react.default.createElement(_Button.Button, {
    isDisc: true,
    type: _Button.buttonTypes.TRANSPARENT_DARK,
    size: _Button.buttonSizes.TINY,
    className: "close-button -tiny-offset",
    icon: _Icons.IconUiCloseXbold,
    onClick: onClick
  });
};

CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = {
  onClick: _propTypes.default.func
};

var Tooltip = function Tooltip(_ref2) {
  var _classnames;

  var type = _ref2.type,
      caretDirection = _ref2.caretDirection,
      position = _ref2.position,
      panel = _ref2.panel,
      heading = _ref2.heading,
      hasCloseButton = _ref2.hasCloseButton,
      onClose = _ref2.onClose,
      children = _ref2.children;
  var classes = (0, _classnames2.default)('tooltip', (_classnames = {
    '-black': type === _constants.tooltipTypes.BLACK
  }, _defineProperty(_classnames, "-caret-".concat(caretDirection), !!caretDirection), _defineProperty(_classnames, "-".concat(position), !!position), _defineProperty(_classnames, '-label', !panel), _defineProperty(_classnames, '-panel', panel), _classnames));
  var contentClass = panel ? 'tooltip__text' : 'tooltip__label';
  return _react.default.createElement("div", {
    className: classes
  }, _react.default.createElement("div", {
    className: "tooltip__caret"
  }), hasCloseButton && _react.default.createElement(CloseButton, {
    onClick: onClose
  }), heading && _react.default.createElement("div", {
    className: "tooltip__heading"
  }, heading), _react.default.createElement("div", {
    className: contentClass
  }, children));
};

Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = {
  /** The type of tooltip */
  type: _propTypes.default.oneOf(Object.values(_constants.tooltipTypes)),

  /** The position of the caret on the tooltip.
   * Values: TOP, TOP_LEFT, TOP_RIGHT, BOTTOM, BOTTOM_LEFT, BOTTOM_RIGHT,
   * LEFT, LEFT_BOTTOM, LEFT_TOP, RIGHT, RIGHT_BOTTOM, RIGHT_TOP
   */
  caretDirection: _propTypes.default.oneOf(Object.values(_constants.tooltipCaretDirections)),

  /** Position of the tooltip relative to its parent.
   * Values: ABOVE, ABOVE_LEFT, ABOVE_RIGHT, BELOW, BELOW_LEFT, BELOW_RIGHT,
   * LEFT, LEFT_BELOW, LEFT_ABOVE, RIGHT, RIGHT_BELOW, RIGHT_ABOVE
   */
  position: _propTypes.default.oneOf(Object.values(_constants.tooltipPosition)),

  /** Set tooltip to display content longer that one line */
  panel: _propTypes.default.bool,

  /** The heading of the tooltip, will be displayed in bold text */
  heading: _propTypes.default.node,

  /** Display close button on tooltip */
  hasCloseButton: _propTypes.default.bool,

  /** on close handler that will be called when the on close button is clicked */
  onClose: _propTypes.default.func,

  /** The content of the tooltip */
  children: _propTypes.default.node
};
Tooltip.defaultProps = {
  caretDirection: _constants.tooltipCaretDirections.TOP
};
var _default = Tooltip;
exports.default = _default;